import React from "react";
import { toast, ToastContainer } from "react-toastify";
import {
  Container,
  Dropdown,
  Form,
  Tab,
  Tabs,
  Row,
  Nav,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Subscriptions } from "./Subscriptions";
import { Rooms } from "./Rooms";
import { EntityManagementService } from "../../../Common/Services/EntityManagementService";
import { Entity } from "./Entity";
import { EntityGroups } from "./EntityGroups";
import { EnableDigitalAch } from "./EnableDigitalAch";
import { Hotel } from "../../../Common/Services/Hotel";

import moment from "moment";
import { Roles } from "../../../Common/Services/RolePermissionSetting";
import { OtpModal } from "../../../Common/Components/OtpModal";
import { accountService } from "../../../Common/Services/account";
import { RolesforTreeView } from "../../../Common/Services/RolePermissionSetting";
import { resolve, reject } from "q";
import { InvoiceApprovalS } from "../../../Common/Services/InvoiceApprovals";
import { confirmAlert } from "react-confirm-alert";
import Spinner from "react-bootstrap/Spinner";
import { Utils } from "../../../Common/Utilis";
;

export class EntityGroupMaster extends React.Component<any, any> {
  private enableDACHButton: any;
  constructor(props: any) {
    super(props);
    this.enableDACHButton = React.createRef();
    this.state = {
      activeTab: "entities",
      hideAddModal: false,
      showDACHButton: false,
      // IsEnableDigitalAchButton: false,
      isDACHEnabled: false,
      showDACHEnableModal: false,
      flyingMenuList: ["Deactivate Digital ACH", "Change Log"],
      fullSubHotelsList: [],
      specialUserList: [],
      otpSuccess: false,
      isOtpNeed: false,
      isAddePay: false,
      isePayFeatureStatus: false,
      isCustIDExist: false,
      ePayCustIDCount: 0,
      isePayEnabled: false,
      ePayPerm: false,
      tyModalForePay: false,
      isePayProcess: false
    };
  }

  componentDidMount() {
    //this.CheckDigitalACHPayments();
    this.GetSpecialPermissionEmployeeList("10110");
    this.getAllEntities();
    this.GetFeatureFlagStatus();
    this.CheckEpayEnabled();
  }

  setActiveTab = (selectedTab) => {
    this.setState({ activeTab: selectedTab });
  };

  openAddEntityModal = (type: any) => {
    let isEpay = type === "ePay";
    if (isEpay) {
      this.CheckAddePayEntityManagementEmail();
    } else {
      this.setState({ hideAddModal: true, isAddePay: isEpay });
    }
    this.setState({ isAddePay: isEpay });
  };

  hideAddEntity = () => {
    this.setState({ hideAddModal: false, isAddePay: false });
  };

  GetFeatureFlagStatus = () => {
    let { isePayFeatureStatus } = this.state;
    RolesforTreeView.GetFeatureFlagStatus()
      .then(async (result: any | null) => {
        if (result != null) {
          isePayFeatureStatus = result.some((o: any) => (o.featureValue.toString().toLocaleLowerCase() === "epay" && o.featureStatus.toString().toLocaleLowerCase() === "yes"));
          this.setState({ isePayFeatureStatus });
        }
        resolve();
      })
      .catch((error) => {
        toast.success(error.message, { position: toast.POSITION.BOTTOM_RIGHT });
        reject();
      });
  }

  CheckEpayEnabled = () => {
    InvoiceApprovalS.CheckEpayEnabled()
      .then(async (result: any) => {
        if (result?.message === "Success") {
          this.setState({
            isCustIDExist: result?.result?.isCustIDExist,
            ePayCustIDCount: result?.result?.ePayCount,
            isePayEnabled: result?.result?.isePayEnabled,
            ePayPerm: result?.result?.disable_EnableEpayPerm,
          });
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error?.message, { position: toast.POSITION.BOTTOM_RIGHT });
        reject();
      });
  };

  openEnableDigitalAch = (type: any) => {
    if (type === "Enable") {
      this.setState({ IsEnableDigitalAch: true, showDACHEnableModal: true });
    } else {
      toast.success(
        "Disable Digital ACH Payments development is under progress..",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      );
    }
  };

  hideEnableDigitalAch = () => {
    this.setState({ showDACHEnableModal: false });
  };

  enableDigitalAch = () => {
    this.setState({ isOtpNeed: true, Purpose: "Enable DACH" }, () => {
      this.ReSendOTP();
    });
    // this.EnableDigitalACHPayments();
  };

  CheckDigitalACHPayments = () => {
    // debugger;
    this.setState({ isDataLoading: true });
    Hotel.CheckDigitalACHPayments()
      .then(async (result: any | null) => {
        if (result != null) {
          if (result.saveStatus === "Success") {
            if (result.message === "False") {
              this.setState({ showDACHButton: true });
            }

            if (result.message === "True") {
              this.setState({
                // IsEnableDigitalAchButton: true,
                isDACHEnabled: true,
                showDACHButton: true,
              });
            } else if (result.message === "NotPermission") {
              this.setState({
                // IsEnableDigitalAchButton: true,
                isDACHEnabled: false,
                showDACHButton: false,
              });
            }
            // this.setState({ showDACHButton: true });
          }
          // if(result.toString()==="Msg"){
          //   toast.success("There is no subscription", {
          //     position: toast.POSITION.BOTTOM_RIGHT,
          //   });
          // }

          //  this.setState({ filteredData: filterdata }, );
        }
      })
      .catch((err) => {
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .finally(() => {
        this.setState({ isDataLoading: false });
      });
  };

  getAllEntities = () => {
    this.setState({ isDataLoading: true });
    Hotel.GetEnableDigitalACHPaymentsHotel()
      .then(async (result: any[] | null) => {
        if (result != null) {
          this.setState({ fullSubHotelsList: result });
        }
      })
      .catch((err) => {
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .finally(() => {
        this.setState({ isDataLoading: false });
      });
  };

  GetSpecialPermissionEmployeeList = (permissionID) => {
    Roles.GetSpecialPermissionEmployeeList(permissionID)
      .then(async (result: any[] | null) => {
        if (result != null) {
          this.setState({ specialUserList: result });
        }
      })
      .catch((error) => {
        Utils.toastError(`Server Error, ${error}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        // this.setState({ loaderTrue: false });
      });
  };

  EnableDigitalACHPayments = () => {
    // debugger;/
    this.setState({ isDataLoading: true });
    this.enableDACHButton.current.disabled = true;
    Hotel.EnableDigitalACHPayments()
      .then(async (result: any | null) => {
        if (result != null) {
          if (result.saveStatus === "Success") {
            this.setState({
              activeTab: "enabledigitalach",
              IsEnableDigitalAch: false,
              // IsEnableDigitalAchButton: false,
              showDACHEnableModal: false,
              isDACHEnabled: true,
            });
            // this.enableDACHButton.current.disabled = false;
            toast.success("Digital ACH payments enabled Successfully.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          } else if (result.saveStatus === "Fail") {
            this.enableDACHButton.current.disabled = false;
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
        }
      })
      .catch((err) => {
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        this.enableDACHButton.current.disabled = false;
      })
      .finally(() => {
        this.setState({ isDataLoading: false });
      });
  };

  ReSendOTP = () => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    // debugger
    let userName = storage === null ? 0 : (storage.userName as any);
    let request: any = {};
    request.userName = userName;
    request.purpose = this.state.Purpose;
    request.otpCode = "";
    request.primaryContact = "Phone";
    accountService
      .OTPForAuthentication(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.status === "Success") {
            toast.success(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "userSlideOut",
            });

            this.setState({ isOtpNeed: true });
          } else {
            Utils.toastError("Something went wrong", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "userSlideOut",
            });
          }
        }
      });
  };

  ValidateOTP = (OTPCode) => {
    this.setState({ otpSuccess: true, isOtpNeed: false }, () => {
      this.EnableDigitalACHPayments();
    });
  };

  closeOtpModal = () => {
    if (this.state.isOtpNeed) {
      this.setState({ isOtpNeed: false });
    }
  };

  disabledePay = (actionType) => {
    let msg = "";
    if (actionType === "Enable")
      msg = "Enabling ePay will allow users to select ePay as the payment method on any invoice.";
    else
      msg = "Disabling ePay will remove the ePay option from any future payments. This will also change any existing invoices currently marked as ePay to use the “Check” payment method.";
    confirmAlert({
      title: "Alert",
      message: msg,
      buttons: [
        {
          label: "Confirm",
          onClick: () => { this.DisableEpay(actionType) },
        },
        {
          label: "Cancel",
          onClick: () => reject(),
        },
      ],
    });
  }

  DisableEpay = (ActionType) => {
    this.setState({ spinner: true });
    Hotel.DisableEpay(ActionType)
      .then(async (result: any | null) => {
        if (result != null) {
          if (result?.result?.message === "Success") {
            toast.success(`ePay has been ${ActionType.toLowerCase()}d successfully.`, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            this.CheckEpayEnabled();
          } else if (result?.result?.message === "NotPerm") {
            Utils.toastError(`You don't have permission to ${ActionType.toLowerCase()} ePay.`, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            return false;
          } else {
            Utils.toastError(`Something went wrong.`, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            return;
          }
        }
      })
      .catch((err) => {
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .finally(() => {
        this.setState({ spinner: false });
      });
  };

  CheckAddePayEntityManagementEmail = () => {
    this.setState({ isePayProcess: true });
    Hotel.CheckAddePayEntityManagementEmail().then(async (result: any | null) => {
      if (result !== null) {
        if (result?.result.toString().toLocaleLowerCase() === "notexists") {
          this.setState({ hideAddModal: true, isePayProcess: false });
        } else if (result?.result.toString().toLocaleLowerCase() === "alreadyexists") {
          this.setState({ tyModalForePay: true, isePayProcess: false }, () => {
            this.hideAddEntity();
          });
        } else {
          this.setState({ isePayProcess: false });
          Utils.toastError(`Something went wrong.`, { position: toast.POSITION.BOTTOM_RIGHT });
        }
      }
    }).catch((err) => {
      this.setState({ isePayProcess: false });
      Utils.toastError(`Server Error, ${err}`, { position: toast.POSITION.BOTTOM_RIGHT });
    })
  }

  handleGetStartedForePay = () => {
    Hotel.AddePayEntityManagementEmail().then(async (result: any | null) => {
      if (result !== null) {
        if (result?.result.toString().toLocaleLowerCase() === "success" || result?.result.toString().toLocaleLowerCase() === "alreadyexists") {
          this.setState({ tyModalForePay: true }, () => {
            this.hideAddEntity();
          });
        } else {
          Utils.toastError(`Something went wrong.`, { position: toast.POSITION.BOTTOM_RIGHT });
        }
      }
    }).catch((err) => {
      Utils.toastError(`Server Error, ${err}`, { position: toast.POSITION.BOTTOM_RIGHT });
    })
  }

  hidetyModalForePay = () => {
    this.setState({ tyModalForePay: false });
  }

  render() {
    const renderTooltip = (props) => {
      return (
        <Tooltip id="tooltip-bottom" {...props}>
          Information about why you should enable digital payments.
        </Tooltip>
      );
    };

    const renderhideTooltip = (props) => {
      return <div id="tooltip-bottom" {...props}></div>;
    };
    const {
      showDACHButton,
      isDACHEnabled,
      showDACHEnableModal,
      flyingMenuList,
      fullSubHotelsList,
      specialUserList,
    } = this.state;
    return (
      <div id="" className="entity-management">
        {/* <ToastContainer containerId={"userSlideOut"} autoClose={3000} /> */}

        <Container fluid className="body-sec">
          {this.state.spinner && (
            <div className="matrixSpinnerCenter">
              <Spinner animation="border" variant="secondary" />
            </div>
          )}
          <div className="page-heading d-flex">
            <div className="mr-auto">Entities</div>
            <div className="action-group d-flex flex-row">
              {/* {showDACHButton && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={false ? renderTooltip : renderhideTooltip}
                >
                  <Button
                    className="disable-enable-digital-ACH-payments btn-outline-primary"
                    onClick={() =>
                      this.openEnableDigitalAch(
                        isDACHEnabled ? "Disable" : "Enable"
                      )
                    }
                  >
                    {`${isDACHEnabled ? "Disable" : "Enable"
                      } Digital ACH Payments`}
                  </Button>
                </OverlayTrigger>
              )} */}
              {this.state.isePayFeatureStatus && this.state.isCustIDExist && this.state.ePayPerm && (
                <Button className="report-gallery" onClick={(e) => { this.disabledePay(this.state.isePayEnabled ? "Disable" : "Enable") }}>
                  {this.state.isePayEnabled ? "Disable ePay" : "Enable ePay"}
                </Button>
              )}
              {this.state.isePayFeatureStatus && !this.state.isCustIDExist && (
                <Button className="report-gallery" disabled={this.state.isePayProcess} onClick={() => this.openAddEntityModal("ePay")}>Add ePay {" "}
                  {this.state.isePayProcess && <Spinner size="sm" className="disabled-area" animation="border" />}
                </Button>
              )}
              <Button
                className="report-gallery"
                onClick={() => this.openAddEntityModal("Add Entity")}
              >
                Add Entity
              </Button>
              <div className="header-popout">
                {/* <Dropdown className="more-action" alignRight>
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary more"
                    id="dropdown-more"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </Dropdown.Toggle>
                      <Dropdown.Menu>
                      {flyingMenuList.map((item,id)=>{
                        if(isDACHEnabled || item !== "Deactivate Digital ACH"){
                          return (
                            <Dropdown.Item
                            key={id}
                            // onClick={() => this.flyOutMenuClick(data)}
                          >
                            {item}
                          </Dropdown.Item>
                          )
                        }
                      })}
                      </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>

          {this.state.hideAddModal && (
            <Modal
              className="add-entity-modal"
              show={this.state.hideAddModal}
              onHide={() => this.hideAddEntity()}
              aria-labelledby="contained-modal-title-vcenter"
              centered
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>{this.state.isAddePay ? (<>Add ePay</>) : (<>Add Entity</>)}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="add-entity-icon">
                  {this.state.isAddePay ?
                    <svg width="108" height="108" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0_2_159" style={{ "maskType": "luminance" }} maskUnits="userSpaceOnUse" x="63" y="64" width="41" height="42">
                        <path d="M63.3601 64.8H103.68V105.626H63.3601V64.8Z" fill="white" />
                      </mask>
                      <g mask="url(#mask0_2_159)">
                        <path d="M84.3919 93.3075V96.2972H82.5835V93.3975C80.9297 93.3609 79.2 92.8491 78.2016 92.1291L78.885 90.2081C79.92 90.8916 81.4163 91.44 83.0194 91.44C85.0641 91.44 86.4366 90.2559 86.4366 88.6163C86.4366 87.0413 85.3088 86.0681 83.1853 85.2047C82.8253 85.0613 82.4822 84.915 82.156 84.7659C79.8441 83.7 78.4547 82.4203 78.4547 80.2266C78.4547 77.8416 80.145 76.0303 82.7916 75.5972V72.6975H84.5663V75.4819C86.2931 75.5466 87.4603 76.005 88.3013 76.4944L87.5813 78.3872C86.9794 78.0413 85.8066 77.4113 83.9728 77.4113C81.7566 77.4113 80.9297 78.7388 80.9297 79.8806C80.9297 81.3234 81.9028 82.0688 84.2063 83.0447C84.2963 83.0841 84.3891 83.1206 84.4819 83.1628C87.435 84.3609 88.9285 85.86 88.9285 88.4194C88.9285 90.6891 87.3535 92.8181 84.3919 93.3075ZM94.2947 68.3494C91.2263 66.4397 87.601 65.3372 83.7281 65.3372C83.2725 65.3372 82.8169 65.3513 82.3697 65.3822C73.8478 65.9419 67.0585 71.7384 64.6706 79.2872C64.1391 80.9578 63.8241 82.7156 63.7594 84.5213C63.6666 87.0384 64.0069 89.4094 64.7016 91.5947C67.3341 99.8438 75.0235 105.376 83.5819 105.429C94.725 105.511 103.852 96.4547 103.632 85.4016C103.793 78.2325 100.013 71.8959 94.2947 68.3494Z" fill="#2CAF92" />
                      </g>
                      <mask id="mask1_2_159" style={{ "maskType": "luminance" }} maskUnits="userSpaceOnUse" x="4" y="2" width="94" height="91">
                        <path d="M4.01074 2.48624H97.2001V92.16H4.01074V2.48624Z" fill="white" />
                      </mask>
                      <g mask="url(#mask1_2_159)">
                        <path d="M96.5391 51.4378C96.0582 46.5834 94.6688 41.985 92.3063 37.7297C87.0751 28.2937 79.2001 22.2384 68.7629 19.5609C68.2454 19.4316 68.0822 19.2628 68.1019 18.7425C68.1385 17.6569 68.1385 16.5628 68.1019 15.4772C68.0879 15.0159 68.2201 14.8162 68.6644 14.6503C71.5669 13.5422 73.2741 10.6622 72.7369 7.86656C72.1182 4.68281 69.6629 2.63531 66.4201 2.62406C62.1985 2.61562 57.9741 2.6325 53.7441 2.62125C52.9201 2.62125 52.1241 2.76187 51.3619 3.06C48.9685 3.98812 47.4441 6.2325 47.4272 8.81437C47.4188 11.3822 48.9066 13.6322 51.3394 14.5687C51.916 14.7853 52.1185 15.0441 52.0847 15.66C52.0257 16.6556 52.0257 17.6569 52.0847 18.6525C52.1185 19.2516 51.916 19.485 51.3479 19.6284C43.3519 21.5916 36.8044 25.8497 31.6069 32.2256C31.2807 32.625 30.9572 32.7572 30.4707 32.7544C28.5976 32.7262 26.7244 32.7431 24.8513 32.7431C22.7138 32.7431 20.5679 32.7375 18.4247 32.7431C17.1479 32.7487 16.3041 33.4884 16.3097 34.5825C16.3154 35.6681 17.0944 36.3628 18.3544 36.3909C18.7735 36.3994 19.1954 36.3909 19.62 36.3909H28.6819C27.5091 38.4581 26.505 40.4634 25.7766 42.5981C25.5713 43.1859 25.2929 43.3491 24.6854 43.3491C18.616 43.3237 12.555 43.3491 6.48286 43.3181C5.40567 43.3125 4.56192 43.5994 3.97974 44.5331V45.8016C4.54786 46.7466 5.37474 47.0672 6.4688 47.0616C12.1107 47.0278 17.761 47.0447 23.4029 47.0447H24.4463C23.9822 49.1484 23.6897 51.2072 23.5997 53.28C23.5688 53.9184 23.3269 53.9859 22.7982 53.9803C20.4722 53.955 18.1491 53.9634 15.8232 53.9691C14.5547 53.9747 13.7841 54.6441 13.7644 55.7437C13.7391 56.8912 14.5154 57.5972 15.8288 57.5972C18.1491 57.6 20.4779 57.6281 22.7982 57.5831C23.4619 57.5691 23.7066 57.7519 23.7207 58.4156C23.7685 60.1087 24.1172 61.7625 24.466 63.4162C24.705 64.5328 24.7191 64.5328 23.5379 64.5328C20.1572 64.5328 16.7766 64.5244 13.3932 64.5328C11.97 64.5384 11.1122 65.3737 11.2304 66.6028C11.3288 67.6181 12.15 68.2481 13.455 68.2481C17.3194 68.2594 21.181 68.2734 25.0454 68.2369C25.7316 68.2284 26.0241 68.4562 26.2772 69.0806C32.2988 83.9025 46.9941 92.6353 62.1282 91.8253C61.4419 89.4741 61.1326 86.9878 61.2282 84.4312C61.2901 82.7803 61.5291 81.18 61.9201 79.6472C61.3238 79.6922 60.7247 79.7119 60.1229 79.7119C46.6482 79.6978 35.6597 68.6559 35.6766 55.1391C35.6907 41.6616 46.6679 30.7041 60.1426 30.7153C73.6651 30.7209 84.6029 41.6925 84.5888 55.2487C84.5888 57.8812 84.1641 60.4209 83.3766 62.8031C83.4976 62.7975 83.6129 62.7975 83.7282 62.7975C87.8204 62.7975 91.7241 63.8691 95.1413 65.88C95.4844 64.7606 95.7741 63.6131 96.0188 62.4487C96.286 61.1353 96.286 59.7797 96.7219 58.5056V51.7894C96.5194 51.75 96.556 51.5812 96.5391 51.4378Z" fill="#2CAF92" />
                      </g>
                      <mask id="mask2_2_159" style={{ "maskType": "luminance" }} maskUnits="userSpaceOnUse" x="4" y="64" width="4" height="5">
                        <path d="M4.01074 64.08H7.92012V68.4H4.01074V64.08Z" fill="white" />
                      </mask>
                      <g mask="url(#mask2_2_159)">
                        <path d="M6.00204 64.5638C5.03454 64.4457 4.47767 65.0616 3.98267 65.7647C3.98267 66.1894 3.98267 66.6141 3.98267 67.036C4.10642 67.1907 4.22735 67.3538 4.3511 67.5057C4.9136 68.1891 5.77985 68.431 6.53079 68.0625C7.30704 67.6828 7.68954 67.0416 7.59954 66.1585C7.51798 65.3597 6.83735 64.6622 6.00204 64.5638Z" fill="#2CAF92" />
                      </g>
                      <path d="M61.9341 72.8831C61.8778 71.8538 61.0397 71.0409 60.075 71.0634C59.1244 71.0888 58.351 71.8622 58.3116 72.8719C58.2891 73.5328 58.2694 74.1966 58.3313 74.8519C58.4353 75.9966 59.6419 76.7166 60.7135 76.3088C61.906 75.8531 62.0185 74.8631 61.9369 73.9069C61.9369 73.485 61.951 73.1841 61.9341 72.8831Z" fill="#2CAF92" />
                      <path d="M79.5599 57.0403C80.5752 56.9841 81.3149 56.205 81.3177 55.2263C81.3261 54.2222 80.6146 53.4769 79.5768 53.4122C79.2758 53.3953 78.9749 53.4094 78.6711 53.4094C78.6711 53.4066 78.6711 53.4037 78.6711 53.4009C78.4321 53.4009 78.1874 53.3953 77.9483 53.4009C76.7699 53.4375 76.0077 54.1491 76.0049 55.2094C76.0049 56.2697 76.7811 57.0178 77.9314 57.0459C78.4743 57.06 79.0199 57.0713 79.5599 57.0403Z" fill="#2CAF92" />
                      <path d="M40.3903 53.4009C39.524 53.5894 39.0487 54.1547 38.9531 55.0181C38.8603 55.8675 39.3637 56.5819 40.185 56.8941C40.6547 57.0769 41.13 57.0009 41.5181 57.0262C41.8781 57.0262 42.1509 57.0431 42.4181 57.0234C43.5037 56.9475 44.2547 56.1994 44.2659 55.1925C44.28 54.2137 43.6106 53.4712 42.5419 53.3503C41.8331 53.2687 41.1047 53.2491 40.3903 53.4009Z" fill="#2CAF92" />
                      <path d="M61.9593 35.7863C61.9031 34.6725 61.1831 33.9722 60.1227 33.9863C59.1187 33.9975 58.3818 34.7147 58.334 35.7553C58.3031 36.3909 58.2918 37.0238 58.3424 37.6594C58.4268 38.6241 59.2115 39.285 60.1846 39.2766C61.1634 39.2625 61.8777 38.5931 61.9537 37.6003C61.9734 37.2938 61.9537 36.9956 61.9537 36.6891C61.9593 36.6891 61.9593 36.6891 61.9621 36.6891C61.9621 36.3909 61.9734 36.0844 61.9593 35.7863Z" fill="#2CAF92" />
                      <path d="M60.269 59.175C58.0808 59.175 56.3061 57.3975 56.3061 55.2038C56.3061 53.0072 58.0808 51.2325 60.269 51.2325C62.4599 51.2325 64.2346 53.0072 64.2346 55.2038C64.2346 57.3975 62.4599 59.175 60.269 59.175ZM66.3355 55.2038C66.3355 54.1547 66.0683 53.1675 65.6043 52.3097C65.6436 52.2647 65.6915 52.2113 65.7393 52.1634C68.4224 49.5056 71.083 46.8281 73.7521 44.1563C74.0924 43.8159 74.4552 43.4869 74.6043 43.0031C74.8602 42.1791 74.5424 41.3213 73.8224 40.8797C73.0068 40.3819 72.2418 40.4888 71.4599 41.2594C68.7233 43.9903 65.984 46.7241 63.2671 49.4747C63.1602 49.5788 63.059 49.6772 62.9521 49.7531C62.1449 49.3538 61.2336 49.1288 60.269 49.1288C59.2368 49.1288 58.2636 49.3875 57.4115 49.8459C57.313 49.7784 57.2174 49.6913 57.1133 49.5872C56.0418 48.4763 54.9477 47.3906 53.8508 46.3106C52.9452 45.4106 51.823 45.3347 51.058 46.1025C50.2818 46.8844 50.3493 47.9644 51.2661 48.9009C52.3208 49.9753 53.384 51.0553 54.4724 52.1044C54.6271 52.2563 54.7424 52.3941 54.8155 52.5403C54.4246 53.3447 54.2052 54.2475 54.2052 55.2038C54.2052 58.5563 56.9193 61.2788 60.269 61.2788C63.6158 61.2788 66.3355 58.5563 66.3355 55.2038Z" fill="#2CAF92" />
                    </svg>
                    :
                    <svg
                      width="100"
                      height="100"
                      viewBox="0 0 100 100"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M49.9999 99.9998C77.6141 99.9998 99.9998 77.6141 99.9998 49.9999C99.9998 22.3857 77.6141 0 49.9999 0C22.3857 0 0 22.3857 0 49.9999C0 77.6141 22.3857 99.9998 49.9999 99.9998Z"
                        fill="#F4F8FB"
                      />
                      <g clip-path="url(#clip0_2076_24727)">
                        <path
                          d="M77.8581 33.3234V76.5719H60.7144L49.2862 73.8922L37.8581 76.5719H20.7144V33.3234L49.2862 16.1797L77.8581 33.3234Z"
                          fill="#FFF3E8"
                        />
                        <path
                          d="M95.0003 70.8561C95.0003 80.3248 87.3253 87.9998 77.8581 87.9998C68.3894 87.9998 60.7144 80.3248 60.7144 70.8561C60.7144 61.3889 68.3894 53.7139 77.8581 53.7139C87.3253 53.7139 95.0003 61.3889 95.0003 70.8561Z"
                          fill="#ECF1F4"
                        />
                        <path
                          d="M95.0001 70.8561C95.0001 80.3248 87.3251 87.9998 77.8579 87.9998V53.7139C87.3251 53.7139 95.0001 61.3889 95.0001 70.8561Z"
                          fill="#DCE6EC"
                        />
                        <path
                          d="M26.4287 8H37.8573V22.1281H26.4287V8Z"
                          fill="#D3412E"
                        />
                        <path
                          d="M37.8579 48H60.7141V76.5719H37.8579V48Z"
                          fill="#D3412E"
                        />
                        <path
                          d="M49.2856 48H60.7138V76.5719H49.2856V48Z"
                          fill="#B12A18"
                        />
                        <path
                          d="M83.5719 28.9859V40.4141L49.2859 19.8422L15 40.4141V28.9859L49.2859 8.41406L83.5719 28.9859Z"
                          fill="#0071B5"
                        />
                        <path
                          d="M83.5716 28.9859V40.4141L49.2856 19.8422V8.41406L83.5716 28.9859Z"
                          fill="#065A8C"
                        />
                        <path
                          d="M37.8579 35.2876H60.7141V39.9751H37.8579V35.2876Z"
                          fill="#0071B5"
                        />
                        <path
                          d="M49.2856 35.2876H60.7138V39.9751H49.2856V35.2876Z"
                          fill="#065A8C"
                        />
                        <path
                          d="M85.5796 68.514V73.2015H80.2015V78.5796H75.514V73.2015H70.1343V68.514H75.514V63.1343H80.2015V68.514H85.5796Z"
                          fill="#1ACAA3"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2076_24727">
                          <rect
                            width="80"
                            height="80"
                            fill="white"
                            transform="translate(15 8)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                </div>
                <div className="add-entity-title">
                  {this.state.isAddePay ? (<>
                    {/* Looking to add ePay for your hotels? */}
                    Are you ready to simplify your payments and embrace <br />a new era of financial efficiency?
                  </>) : (<>Looking at add another account?</>)}
                </div>
                <div className="add-entity-desc">
                  {/* We'll need to collect some basic information from you to get
                  started. Use the chat on the bottom of the screen or call us
                  and we'd be happy to help. */}
                  {this.state.isAddePay ? (<>
                    {/* Please contact Support using the Chat feature, or contact us via phone at (919) 277-9027 and we can provide information on the next steps. */}
                  </>) : (<>
                    If you're trying to add a new account, we need to collect
                    basic information to set up the entity. Please contact Support
                    using the Chat feature, or contact us via phone at (919)
                    277-9027.
                  </>)}
                </div>
                {this.state.isAddePay && (
                  <div className="d-flex justify-content-center">
                    <Button onClick={this.handleGetStartedForePay}>Get Started</Button>
                  </div>
                )}
                {/* <div className="add-entity-btn">
                  <Button className="btn-outline-primary">
                    Call 1-919-277-9027
                  </Button>
                </div> */}
              </Modal.Body>
            </Modal>
          )}

          {showDACHEnableModal && (
            <Modal
              className="enable-disable-digital-ACH-payments-modal"
              show={showDACHEnableModal}
              onHide={() => this.hideEnableDigitalAch()}
              aria-labelledby="contained-modal-title-vcenter"
              centered
              keyboard={false}
            >
              <Modal.Body>
                <div className="add-entity-icon">
                  <svg
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M49.9999 99.9998C77.6141 99.9998 99.9998 77.6141 99.9998 49.9999C99.9998 22.3857 77.6141 0 49.9999 0C22.3857 0 0 22.3857 0 49.9999C0 77.6141 22.3857 99.9998 49.9999 99.9998Z"
                      fill="#F4F8FB"
                    />
                    <path
                      d="M22.0339 21H76.9491C77.4886 21 78.0059 21.2143 78.3873 21.5957C78.7688 21.9771 78.983 22.4945 78.983 23.0339V51.5085H20V23.0339C20 22.4945 20.2143 21.9771 20.5957 21.5957C20.9771 21.2143 21.4945 21 22.0339 21Z"
                      fill="#D1E7F8"
                    />
                    <path
                      d="M52.542 51.5085H78.9827V25.0679C78.9827 28.5401 78.2988 31.9784 76.97 35.1863C75.6412 38.3942 73.6936 41.309 71.2384 43.7643C66.2798 48.7228 59.5545 51.5085 52.542 51.5085Z"
                      fill="#BDDBFF"
                    />
                    <path
                      d="M65.7625 42.3561C70.2557 42.3561 73.8981 38.7137 73.8981 34.2206C73.8981 29.7274 70.2557 26.085 65.7625 26.085C61.2694 26.085 57.627 29.7274 57.627 34.2206C57.627 38.7137 61.2694 42.3561 65.7625 42.3561Z"
                      fill="#FF6243"
                    />
                    <path
                      d="M41.356 39.3052H45.4238V47.4408H41.356V39.3052Z"
                      fill="#9BC9FF"
                    />
                    <path
                      d="M33.2202 39.3052H37.288V47.4408H33.2202V39.3052Z"
                      fill="#9BC9FF"
                    />
                    <path
                      d="M53.5595 35.2374H25.085L39.3222 25.0679L53.5595 35.2374Z"
                      fill="#9BC9FF"
                    />
                    <path
                      d="M27.1187 35.2373H51.5254V39.3051H27.1187V35.2373Z"
                      fill="#2488FF"
                    />
                    <path
                      d="M39.322 33.2035C40.4453 33.2035 41.3559 32.2929 41.3559 31.1696C41.3559 30.0463 40.4453 29.1357 39.322 29.1357C38.1987 29.1357 37.2881 30.0463 37.2881 31.1696C37.2881 32.2929 38.1987 33.2035 39.322 33.2035Z"
                      fill="#F1F2F2"
                    />
                    <path
                      d="M26.1016 47.4409H52.5422V51.5087H26.1016V47.4409Z"
                      fill="#2488FF"
                    />
                    <path
                      d="M65.7625 46.424C70.2557 46.424 73.8981 42.7816 73.8981 38.2884C73.8981 33.7953 70.2557 30.1528 65.7625 30.1528C61.2694 30.1528 57.627 33.7953 57.627 38.2884C57.627 42.7816 61.2694 46.424 65.7625 46.424Z"
                      fill="#FF7956"
                    />
                    <path
                      d="M52.5424 51.5083H20V55.5761C20 56.1155 20.2143 56.6329 20.5957 57.0143C20.9771 57.3957 21.4945 57.61 22.0339 57.61H76.9491C77.4886 57.61 78.0059 57.3957 78.3873 57.0143C78.7688 56.6329 78.983 56.1155 78.983 55.5761V51.5083H52.5424Z"
                      fill="#006DF0"
                    />
                    <path
                      d="M73.4773 70.4094C73.0959 70.028 72.5787 69.8136 72.0393 69.8135H26.9437C26.4043 69.8136 25.8871 70.028 25.5058 70.4094L20 75.9152H78.983L73.4773 70.4094Z"
                      fill="#D1D3D4"
                    />
                    <path
                      d="M20 77.9489C20 78.4884 20.2143 79.0057 20.5957 79.3871C20.9771 79.7686 21.4945 79.9828 22.0339 79.9828H76.9491C77.4886 79.9828 78.0059 79.7686 78.3873 79.3871C78.7688 79.0057 78.983 78.4884 78.983 77.9489V75.915H20V77.9489Z"
                      fill="#005ECE"
                    />
                    <path
                      d="M44.4067 57.6104H54.5762V62.6951H44.4067V57.6104Z"
                      fill="#808285"
                    />
                    <path
                      d="M38.3049 62.6948C37.7655 62.6948 37.2481 62.9091 36.8667 63.2905C36.4853 63.672 36.271 64.1893 36.271 64.7287V66.7626H62.7117V64.7287C62.7117 64.1893 62.4974 63.672 62.116 63.2905C61.7345 62.9091 61.2172 62.6948 60.6778 62.6948H38.3049Z"
                      fill="#004FAC"
                    />
                    <path
                      d="M37.2881 39.3052H41.3559V47.4408H37.2881V39.3052Z"
                      fill="#57A4FF"
                    />
                    <path
                      d="M29.1528 39.3052H33.2206V47.4408H29.1528V39.3052Z"
                      fill="#57A4FF"
                    />
                    <path
                      d="M45.4238 39.3052H49.4916V47.4408H45.4238V39.3052Z"
                      fill="#57A4FF"
                    />
                    <path
                      d="M44.4067 57.6104H54.5762V59.6442H44.4067V57.6104Z"
                      fill="#6D6E71"
                    />
                    <path
                      d="M66.7796 44.3898V43.2711C68.5501 42.9386 69.8304 41.7691 69.8304 40.322C69.8304 38.6115 68.0436 37.2711 65.7626 37.2711C64.5209 37.2711 63.7287 36.6691 63.7287 36.2542C63.7287 35.8393 64.5209 35.2372 65.7626 35.2372C67.0043 35.2372 67.7965 35.8393 67.7965 36.2542C67.7965 36.5239 67.9037 36.7826 68.0944 36.9733C68.2851 37.164 68.5438 37.2711 68.8135 37.2711C69.0832 37.2711 69.3418 37.164 69.5326 36.9733C69.7233 36.7826 69.8304 36.5239 69.8304 36.2542C69.8304 34.8091 68.5501 33.6396 66.7796 33.305V32.1864C66.7796 31.9167 66.6724 31.658 66.4817 31.4673C66.291 31.2766 66.0323 31.1694 65.7626 31.1694C65.4929 31.1694 65.2342 31.2766 65.0435 31.4673C64.8528 31.658 64.7457 31.9167 64.7457 32.1864V33.305C62.9752 33.6376 61.6948 34.8071 61.6948 36.2542C61.6948 37.9647 63.4816 39.305 65.7626 39.305C67.0043 39.305 67.7965 39.9071 67.7965 40.322C67.7965 40.7369 67.0043 41.3389 65.7626 41.3389C64.5209 41.3389 63.7287 40.7369 63.7287 40.322C63.7287 40.0523 63.6216 39.7936 63.4309 39.6029C63.2402 39.4122 62.9815 39.305 62.7118 39.305C62.4421 39.305 62.1834 39.4122 61.9927 39.6029C61.802 39.7936 61.6948 40.0523 61.6948 40.322C61.6948 41.7671 62.9752 42.9366 64.7457 43.2711V44.3898C64.7457 44.6595 64.8528 44.9181 65.0435 45.1089C65.2342 45.2996 65.4929 45.4067 65.7626 45.4067C66.0323 45.4067 66.291 45.2996 66.4817 45.1089C66.6724 44.9181 66.7796 44.6595 66.7796 44.3898Z"
                      fill="#ED1C24"
                    />
                    <path
                      d="M29.153 71.8477H28.1361C27.8664 71.8477 27.6077 71.9548 27.417 72.1455C27.2263 72.3362 27.1191 72.5949 27.1191 72.8646C27.1191 73.1343 27.2263 73.393 27.417 73.5837C27.6077 73.7744 27.8664 73.8816 28.1361 73.8816H29.153C29.4228 73.8816 29.6814 73.7744 29.8721 73.5837C30.0628 73.393 30.17 73.1343 30.17 72.8646C30.17 72.5949 30.0628 72.3362 29.8721 72.1455C29.6814 71.9548 29.4228 71.8477 29.153 71.8477Z"
                      fill="#F1F2F2"
                    />
                    <path
                      d="M66.7797 71.8477H32.2035C31.9338 71.8477 31.6751 71.9548 31.4844 72.1455C31.2937 72.3362 31.1865 72.5949 31.1865 72.8646C31.1865 73.1343 31.2937 73.393 31.4844 73.5837C31.6751 73.7744 31.9338 73.8816 32.2035 73.8816H66.7797C67.0495 73.8816 67.3081 73.7744 67.4988 73.5837C67.6896 73.393 67.7967 73.1343 67.7967 72.8646C67.7967 72.5949 67.6896 72.3362 67.4988 72.1455C67.3081 71.9548 67.0495 71.8477 66.7797 71.8477Z"
                      fill="#F1F2F2"
                    />
                    <path
                      d="M68.814 72.8646C68.814 73.1343 68.9211 73.393 69.1118 73.5837C69.3025 73.7744 69.5612 73.8816 69.8309 73.8816H70.8479C71.1176 73.8816 71.3762 73.7744 71.567 73.5837C71.7577 73.393 71.8648 73.1343 71.8648 72.8646C71.8648 72.5949 71.7577 72.3362 71.567 72.1455C71.3762 71.9548 71.1176 71.8477 70.8479 71.8477H69.8309C69.5612 71.8477 69.3025 71.9548 69.1118 72.1455C68.9211 72.3362 68.814 72.5949 68.814 72.8646Z"
                      fill="#F1F2F2"
                    />
                    <path
                      d="M50.5089 53.5425H48.475C48.2052 53.5425 47.9466 53.6496 47.7559 53.8403C47.5651 54.0311 47.458 54.2897 47.458 54.5594C47.458 54.8291 47.5651 55.0878 47.7559 55.2785C47.9466 55.4692 48.2052 55.5764 48.475 55.5764H50.5089C50.7786 55.5764 51.0372 55.4692 51.2279 55.2785C51.4187 55.0878 51.5258 54.8291 51.5258 54.5594C51.5258 54.2897 51.4187 54.0311 51.2279 53.8403C51.0372 53.6496 50.7786 53.5425 50.5089 53.5425Z"
                      fill="#F1F2F2"
                    />
                    <path
                      d="M67.7969 62.6951H76.9495C77.2192 62.6951 77.4779 62.8022 77.6686 62.993C77.8593 63.1837 77.9664 63.4423 77.9664 63.712C77.9664 63.9818 77.8593 64.2404 77.6686 64.4311C77.4779 64.6219 77.2192 64.729 76.9495 64.729H71.8647C71.0563 64.7314 70.2818 65.0536 69.7101 65.6252C69.1385 66.1969 68.8163 66.9715 68.8139 67.7798V69.8137H70.8478V67.7798C70.8478 67.5101 70.9549 67.2515 71.1456 67.0608C71.3364 66.87 71.595 66.7629 71.8647 66.7629H76.9495C77.7586 66.7629 78.5346 66.4415 79.1068 65.8693C79.6789 65.2972 80.0003 64.5212 80.0003 63.712C80.0003 62.9029 79.6789 62.1269 79.1068 61.5548C78.5346 60.9826 77.7586 60.6612 76.9495 60.6612H67.7969C67.5272 60.6612 67.2686 60.5541 67.0778 60.3633C66.8871 60.1726 66.78 59.914 66.78 59.6442V57.6104H64.7461V59.6442C64.7485 60.4526 65.0707 61.2272 65.6423 61.7989C66.214 62.3705 66.9885 62.6927 67.7969 62.6951Z"
                      fill="#FF5023"
                    />
                    <path
                      d="M27.1187 35.2373H51.5254V36.2543H27.1187V35.2373Z"
                      fill="#006DF0"
                    />
                  </svg>
                </div>
                <div
                  className="cross-btn"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => this.hideEnableDigitalAch()}
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24.5001 14L19.9995 18.4995L15.4999 14L14 15.4998L18.4996 19.9993L14 24.4988L15.4999 25.9986L19.9995 21.4991L24.5001 25.9986L26 24.4988L21.5004 19.9993L26 15.4998L24.5001 14Z"
                      fill="#84888C"
                    />
                  </svg>
                </div>
                <div className="add-entity-title">
                  Enable Digital ACH Payments
                </div>
                <div className="add-entity-desc">
                  {/* We'll need to collect some basic information from you to get
                  started. Use the chat on the bottom of the screen or call us
                  and we'd be happy to help. */}
                  Digital ACH Payments Allow your hotels to make payments for
                  invoices directly from the bank account of your choosing.
                </div>
                <div className="add-entity-desc">
                  After enabling, you will need to go through verification and
                  set up bank information for each entity.
                </div>

                <div className="add-entity-btn">
                  {/* <Button className="btn-outline-primary" onClick={() => this.enableDigitalAch()}>
                    Submit
                  </Button> */}

                  <Button
                    ref={this.enableDACHButton}
                    className="report-gallery"
                    onClick={() => this.enableDigitalAch()}
                  >
                    Enable Digital ACH Payments
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
          )}

          {this.state.tyModalForePay && (
            <Modal
              className="enable-disable-digital-ACH-payments-modal"
              show={this.state.tyModalForePay}
              onHide={() => this.hidetyModalForePay()}
              aria-labelledby="contained-modal-title-vcenter"
              centered
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Thank You!</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="add-entity-title">
                  Our support team will be in touch soon with next steps.
                </div>
              </Modal.Body>
            </Modal>
          )}

          {this.state.isOtpNeed && (
            <OtpModal
              closePopup={this.closeOtpModal.bind(this)}
              ValidateOTP={this.ValidateOTP.bind(this)}
              ReSendOTP={this.ReSendOTP.bind(this)}
              purpose={this.state.Purpose}
            ></OtpModal>
          )}

          <Tab.Container
            activeKey={this.state.activeTab}
            onSelect={(selectedtab) => this.setActiveTab(selectedtab)}
            id="left-tabs-example"
            defaultActiveKey="entities"
          >
            <Nav className="nav-tabs flex-row">
              <Nav.Item>
                <Nav.Link eventKey="entities">Entities</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="groups">Categories &amp; Groups </Nav.Link>
              </Nav.Item>

              {/* {isDACHEnabled && (
                <Nav.Item>
                  <Nav.Link eventKey="enabledigitalach">
                    Digital ACH Payments
                  </Nav.Link>
                </Nav.Item>
              )} */}
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="entities">
                {this.state.activeTab === "entities" && (
                  <Entity
                    digitalACHEnabled={isDACHEnabled}
                    fullSubHotelsList={fullSubHotelsList}
                    specialUserList={specialUserList}
                  />
                )}
              </Tab.Pane>

              <Tab.Pane eventKey="groups">
                {this.state.activeTab === "groups" && <EntityGroups />}
              </Tab.Pane>
              {/* {isDACHEnabled && (
                <Tab.Pane eventKey="enabledigitalach">
                  {this.state.activeTab === "enabledigitalach" && (
                    <EnableDigitalAch
                      digitalACHEnabled={isDACHEnabled}
                      fullSubHotelsList={fullSubHotelsList}
                      specialUserList={specialUserList}
                    />
                  )}
                </Tab.Pane>
              )} */}
            </Tab.Content>
          </Tab.Container>
        </Container>
      </div>
    );
  }
}
